'use strict';

/**
 * @ngdoc service
 * @name thothApp.services:ImportPendingList
 * @description
 * # ImportPendingList
 * Lista de eventos de Google todavia no importados al SIA.
 *
 * Siempre se trabaja por identificador: el calendario entrega una copia del
 * evento, no el objeto de la lista, y comparar por referencia falla en silencio.
 */
angular.module('thothApp.services')
  .factory('ImportPendingList', [function () {

    var UNCLASSIFIED_COLOR = '#9e2a2a';

    var COLORS = {
      project: '#4153c8',
      support: '#df6c11',
      quote: '#7a7db3',
      rh: '#4682b4',
      vacation: '#5F9EA0'
    };

    var CLASSIFIABLE = [
      'actionType', 'description', 'clientId', 'clientName', 'ownerableType',
      'activityTypeCatalogId', 'projectId', 'projectName', 'project_code',
      'productId', 'ticketId', 'ticketName'
    ];

    function colorFor(actionType) {
      return COLORS[actionType] || UNCLASSIFIED_COLOR;
    }

    function find(list, id) {
      return (list || []).filter(function (item) { return item.id === id; })[0] || null;
    }

    // No toca _originalClassification: esa foto es la que mide la correccion.
    function classify(list, id, values) {
      var pending = find(list, id);
      if (!pending) {
        return null;
      }

      CLASSIFIABLE.forEach(function (field) {
        if (Object.prototype.hasOwnProperty.call(values, field)) {
          pending[field] = values[field] === undefined ? null : values[field];
        }
      });

      pending.needsClassification = !pending.actionType;
      pending.isValidate = !!pending.actionType;
      pending.title = pending.description;
      pending.color = colorFor(pending.actionType);

      return pending;
    }

    // El pendiente todavia no existe en el SIA: el horario nuevo vive en la lista.
    function reschedule(list, id, start, end) {
      var pending = find(list, id);
      if (!pending || !start || !end) {
        return null;
      }

      pending.start = start;
      pending.end = end;

      return pending;
    }

    function discard(pending, discarded, id) {
      var target = find(pending, id);
      if (!target) {
        return { pending: pending, discarded: discarded };
      }

      return {
        pending: pending.filter(function (item) { return item.id !== id; }),
        discarded: discarded.concat([target])
      };
    }

    // Un descartado que ya volvio a la lista no se agrega dos veces.
    function restore(pending, discarded) {
      var missing = (discarded || []).filter(function (item) {
        return !find(pending, item.id);
      });

      return { pending: pending.concat(missing), discarded: [] };
    }

    // Sin esto el evento ya importado se veria encima de su propia actividad.
    function withoutAlreadyImported(pending, siaActivities) {
      var imported = (siaActivities || [])
        .map(function (activity) { return activity.google_calendar_id; })
        .filter(function (id) { return !!id; });

      return (pending || []).filter(function (item) {
        return imported.indexOf(item.id) === -1;
      });
    }

    // El SIA exige tipo de accion: sin el, la actividad no se puede guardar.
    function importable(list) {
      return (list || []).filter(function (item) { return !!item.actionType; });
    }

    function blocked(list) {
      return (list || []).filter(function (item) { return !item.actionType; });
    }

    // Columnas jsonb: van objetos, no texto JSON, o se guardan como cadena.
    function toImportPayload(pending, classificationChanges) {
      var payload = {
        begins_at: pending.start,
        ends_at: pending.end,
        description: pending.description,
        action_type: pending.actionType,
        activity_type_catalog_id: pending.activityTypeCatalogId || null,
        ownerable_id: pending.clientId || null,
        ownerable_type: pending.ownerableType || null,
        project_id: pending.projectId || null,
        product_catalog_id: pending.productId || null,
        ticket_id: pending.ticketId || null,
        ticket_name: pending.ticketName || null,
        google_calendar_id: pending.id,
        google_calendar_event: pending.google_calendar_event || null,
        attendees: pending.attendees || []
      };

      if (classificationChanges) {
        payload.classification_metadata = pending._originalClassification;
        payload.classification_changes = classificationChanges;
        payload.is_correctly_classified = classificationChanges.length === 0;
      }

      return payload;
    }

    return {
      COLORS: COLORS,
      UNCLASSIFIED_COLOR: UNCLASSIFIED_COLOR,
      colorFor: colorFor,
      find: find,
      classify: classify,
      reschedule: reschedule,
      discard: discard,
      restore: restore,
      importable: importable,
      blocked: blocked,
      withoutAlreadyImported: withoutAlreadyImported,
      toImportPayload: toImportPayload
    };
  }]);
